import ListViewScreen from "./components/list_view_screen"

export default function Show({ posts }) {
  return <ListViewScreen posts={posts} mode="list" />
}
